<script setup lang="ts">
import { CheckCircle2, CircleAlert, Info } from 'lucide-vue-next'
import { useUiStore } from '@/stores/ui'

const ui = useUiStore()
</script>

<template>
  <div class="toast-stack" aria-live="polite">
    <button v-for="item in ui.toasts" :key="item.id" class="toast" :class="item.type" type="button" @click="ui.dismiss(item.id)">
      <CircleAlert v-if="item.type === 'error'" />
      <Info v-else-if="item.type === 'info'" />
      <CheckCircle2 v-else />
      <span>{{ item.message }}</span>
    </button>
  </div>
</template>
